module.exports = __webpack_public_path__ + "static/sutton-logo-e11bec61c3882fcc4c1145b0f9b1a167.jpeg";